export const config = {
  s3bucket: 'https://hpl-images.s3.amazonaws.com',
  apiBaseURL: 'https://api.hplelevadores.com.br/v1',
//  apiBaseURL: 'http://localhost:3008/v1',
  apiTimeout: 180000
};